<div
  class="wrapper"
  [@openCloseFilterBar]="shown ? 'open' : 'close'"
  (@openCloseFilterBar.done)="onFinishToggle($event)"
>
  <div class="fixed-header">
    <ng-container *ngIf="showCurrentDeliveries && deliveries.length > 1">
      <p class="title">{{ deliveriesLabel | uppercase | translate }}</p>
      <div class="deliveries" [class.open]="openCurrentDelivery">
        <span
          class="current"
          (click)="toggleDeliveriesMenu()"
          (appClickOutside)="openCurrentDelivery = false"
        >
          <span class="name">{{ currentDelivery.name }}</span>
        </span>
        <div class="selector">
          <div class="header">
            <p>{{ deliveriesLabel | translate }}</p>
          </div>
          <div class="scroll-container custom-scrollbar">
            <ul>
              <li
                *ngFor="let delivery of deliveries"
                [class.selected]="isDeliverySelected(delivery, false)"
                (click)="changeDelivery(delivery)"
              >
                {{ delivery.label }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
    <div
      class="deliveries compare"
      [class.open]="openCompareDeliveries"
      *ngIf="showCompareDeliveries && deliveries.length > 1"
    >
      <span
        class="current"
        [class.has-value]="compareDelivery"
        (appClickOutside)="openCompareDeliveries = false"
        (click)="toggleCompareDeliveriesMenu()"
      >
        <span class="name">
          {{
            compareDelivery
              ? (compareDelivery.name | translate)
              : (compareSelectorLabel | translate)
          }}
        </span>
        <button
          [attr.data-tooltip]="'Discard' | translate"
          (click)="$event.stopPropagation(); changeCompareDelivery(null)"
          class="generic-tooltip close-btn"
        ></button>
      </span>
      <div class="selector">
        <div class="header">
          <p>{{ deliveriesLabel | translate }}</p>
        </div>
        <div class="scroll-container custom-scrollbar">
          <ul>
            <li
              *ngFor="let delivery of compareDeliveries"
              [class.selected]="isDeliverySelected(delivery, true)"
              (click)="changeCompareDelivery(delivery)"
            >
              {{ delivery.label }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="switch-wrapper" *ngIf="isVisitsAvailable">
      <p class="title">{{ 'Key Indicator' | translate }}</p>
      <app-btn-group
        class="switch"
        (optionSelected)="onKeyIndicatorChange($event)"
        [selectedValue]="keyIndicator"
        [options]="keyIndicatorOptions"
      ></app-btn-group>
    </div>
    <p class="title filters">{{ 'Filters' | translate }}</p>
  </div>
  <div class="custom-scrollbar">
    <app-category-filter
      class="main-filter"
      *ngFor="let filter of filters"
      [filter]="filter"
      (onChange)="onFilterChange(filter, $event)"
    >
    </app-category-filter>
    <app-category-filter
      class="target-filter"
      #targetCmp
      *ngIf="target"
      id="target"
      [filter]="target"
      (onChange)="onFilterChange(target, $event)"
    >
    </app-category-filter>
  </div>
</div>
<div
  class="toggleBtn generic-tooltip"
  (click)="togglePanel()"
  [attr.data-tooltip]="'Toggle filters' | translate"
  [@openCloseToggleBtn]="shown ? 'open' : 'close'"
>
  <img
    *ngIf="shown"
    src="/assets/img/icons/negative/arrow_collapse.svg"
    class="icon"
  />
  <img *ngIf="!shown" src="/assets/img/icons/accent/filters.svg" class="icon" />
</div>
<div
  class="filter-disable-overlay"
  [class.has-visits-visitors]="isVisitsAvailable"
>
  <p class="message">
    <img src="/assets/img/icons/color/warning-s.svg" alt="warning icon" />
    <span>{{ 'Filters are not available for this section' | translate }}</span>
  </p>
</div>
